import { Typography } from "@mui/material";

function ItemUsersStatistic({ title, value }) {
  return (
    <Typography color="common.white" marginBottom={3} textAlign="right">
      <Typography variant="h5" component="span">
        {title}:{" "}
      </Typography>

      <Typography variant="h5" component="span">
        {value}
      </Typography>
    </Typography>
  );
}

export default ItemUsersStatistic;
